import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"fog"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 13C21 11.3939 20.0926 9.65847 18.7445 8.90998C18.0838 8.54318 17.3174 8.33333 16.5 8.33333C16.4751 8.33333 16.4502 8.33353 16.4254 8.33392C16.0716 6.30141 14.4933 4.66861 12.4459 4.16281C12.0157 4.05652 11.5647 4 11.1 4C8.11766 4 5.7 6.32812 5.7 9.2C5.7 9.52608 5.73117 9.84515 5.79079 10.1546C4.25293 10.1546 3 11.5 3 13","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M3 16H7M3 20L14 20M11 16H21M18 20H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Fog = Vue.extend<IconProps>({
  name: 'FogIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'fog',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Fog;
